var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "slider-combo" },
    [
      _c("p", [
        _vm._v(_vm._s(_vm.label) + " ("),
        _c("b", [_vm._v(_vm._s(_vm.filter.min))]),
        _vm._v(" - "),
        _c("b", [_vm._v(_vm._s(_vm.filterMax))]),
        _vm._v(")")
      ]),
      _vm._v(" "),
      _c(
        "v-layout",
        [
          _c(
            "v-flex",
            { attrs: { xs4: "", sm3: "" } },
            [
              _c("v-text-field", {
                staticClass:
                  "field-input form-fields-slider-text-input no-input-details",
                attrs: {
                  "hide-details": "",
                  type: "number",
                  box: "",
                  height: "40px",
                  label: "",
                  title: "",
                  required: _vm.filter.required
                },
                on: {
                  keyup: function($event) {
                    return _vm.debounceTextFieldChange()
                  }
                },
                model: {
                  value: _vm.textLocalModel,
                  callback: function($$v) {
                    _vm.textLocalModel = $$v
                  },
                  expression: "textLocalModel"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { sm8: "" } },
            [
              _c("custom-slider", {
                ref: "slider",
                staticClass: "form-fields-slider",
                attrs: {
                  min: _vm.filterMin,
                  max: _vm.filterMax,
                  "inverse-label": "",
                  "thumb-size": _vm.localModel > 999 ? 32 : 24,
                  "thumb-label": _vm.localModel > 0 ? "always" : true,
                  label: _vm.buildUnit(),
                  title: _vm.label,
                  step: _vm.filter.step
                },
                on: {
                  change: function($event) {
                    return _vm.sliderValueChanged()
                  }
                },
                model: {
                  value: _vm.localModel,
                  callback: function($$v) {
                    _vm.localModel = $$v
                  },
                  expression: "localModel"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a2d38508", { render: render, staticRenderFns: staticRenderFns })
  }
}